import { render, staticRenderFns } from "./GireseExpediente.vue?vue&type=template&id=be8ef4cc&scoped=true&"
import script from "./GireseExpediente.vue?vue&type=script&lang=js&"
export * from "./GireseExpediente.vue?vue&type=script&lang=js&"
import style0 from "./GireseExpediente.vue?vue&type=style&index=0&id=be8ef4cc&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be8ef4cc",
  null
  
)

export default component.exports